<header class="header-container" [class.has-subheader]="hasStepper || hasBasket">
  <div class="header-content" #serviceNav>
    <nav class="header-links">
      <a href="https://www.visana.ch" tabindex="-1" class="visana-logo"
        ><img alt="Logo" src="assets/logos/white.svg"
      /></a>
      <span class="backlink nav-link">
        <a href="https://www.visana.ch">
          <img alt="" class="nav-icon" src="assets/img/pfeil-links.svg" />
          {{ 'HEADER.HOME' | translate }}
        </a>
      </span>
      <span class="nav-link appname">
        {{ 'HEADER.PREMIUM_CALCULATOR' | translate }}
      </span>
    </nav>
    <div class="right-item">
      <ssc-language-selector [displayInHeader]="true"></ssc-language-selector>
    </div>
  </div>
</header>

<div class="subheader" *ngIf="hasStepper || hasBasket" [class.has-basket]="hasBasket && (hasPersons$ | async)">
  <ssc-stepper-clickable
    *ngIf="hasStepper && (steps$ | async) as steps"
    [steps]="steps"
    [isClickable]="hasPersons$ | async"
  ></ssc-stepper-clickable>

  <ng-container *ngIf="hasBasket && (hasPersons$ | async)">
    <ssc-basket [activePersonId$]="activePersonId$" [headerHeight]="headerHeight"></ssc-basket>
  </ng-container>
</div>
